import usePaginationParams from 'app/hooks/usePaginationParams';
import { FilterParams } from 'app/types/Filters';
import { SelectOption } from 'app/types/Forms';
import { useNamedModels } from 'components/Dashboard/Orgs/Wizard/OrgModels/hooks';
import { FilterProps } from 'components/Dashboard/types';
import { useAppSelector } from 'store/hooks';
import { selectModelsApi } from 'store/exec/execSlice';

import { Button, Form, Select, Space } from 'antd';
import React, { useEffect, useMemo } from 'react';

const OrgsFilter: React.FC<FilterProps> = ({ onApply }) => {
  const { isLoading, namedModels, fetchNamedModels } = useNamedModels();
  const modelsApi = useAppSelector(selectModelsApi);
  const [ form ] = Form.useForm<FilterParams>();
  const {
    modelParam,
    modelApiParam,
    setFilters,
    clearFilters,
  } = usePaginationParams();

  useEffect(() => {
    const abortController = new AbortController();
    fetchNamedModels(undefined, abortController);

    return () => {
      abortController.abort();
    };
  }, [ fetchNamedModels ]);

  const namedModelOptions: SelectOption[] = useMemo(
    () => namedModels.map(m => ({ label: m.modelName, value: m.modelName })),
    [ namedModels ],
  );

  const onReset = () => {
    form.setFieldValue('model', []);
    form.setFieldValue('modelApi', undefined);
    clearFilters();
  };

  const onFinish = (values: FilterParams) => {
    setFilters(values);
    onApply();
  };

  return (
    <Form
      form={form}
      name="orgsFilter"
      layout="vertical"
      requiredMark={false}
      onFinish={onFinish}
      style={{ width: 290 }}
      initialValues={{
        model: modelParam !== '' ? modelParam.split(',') : undefined,
        modelApi: modelApiParam !== '' ? modelApiParam.split(',') : undefined,
      }}
    >
      <Form.Item name="model" label="Model">
        <Select placeholder="Select model" mode="multiple" options={namedModelOptions} allowClear loading={isLoading} />
      </Form.Item>

      <Form.Item name="modelApi" label="Model API">
        <Select placeholder="Select model API" mode="multiple" options={modelsApi} allowClear />
      </Form.Item>

      <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
        <Space>
          <Button onClick={onReset}>
            Reset
          </Button>
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default OrgsFilter;
